export default "<navbar></navbar>\r\n<router-outlet></router-outlet>\r\n<bottom-menu></bottom-menu>"